import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';

import { useShouldShowCallsPage } from '@/hooks/useShouldShowCallsPage';

/**
 * Validates that the Calls page should be accessible based on workflow type
 * and whether the user has any calls. Waits for the API check to complete
 * before deciding to redirect.
 */
export const CallsRouteValidator: React.FC = () => {
  const { shouldShow, isLoading } = useShouldShowCallsPage();

  // Wait for the API check before redirecting
  if (isLoading) {
    return null;
  }

  // If Calls page shouldn't be shown, redirect to cases
  if (!shouldShow) {
    return <Navigate to="cases" replace />;
  }

  // Valid access, render child routes
  return <Outlet />;
};
